export enum PageType {
  TERMS_CONDITIONS_FOR_TEACHERS = "terms-conditions-for-teachers",
  TERMS_CONDITIONS_FOR_PARENTS = "terms-conditions-for-parents",
  PRIVACY_POLICY = "privacy-policy",
  REFUND_POLICY = "refund-policy",
  ABOUT_US = "about-us",
}
